var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48px",
    height: "48px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.905
    },
    fill: "#000000",
    d: "M 22.5,-0.5 C 23.1667,-0.5 23.8333,-0.5 24.5,-0.5C 25.6253,1.12879 26.9586,2.62879 28.5,4C 23.1667,9.33333 17.8333,14.6667 12.5,20C 24.1619,20.4999 35.8286,20.6665 47.5,20.5C 47.5,22.5 47.5,24.5 47.5,26.5C 35.8286,26.3335 24.1619,26.5001 12.5,27C 17.8333,32.3333 23.1667,37.6667 28.5,43C 26.9586,44.3712 25.6253,45.8712 24.5,47.5C 23.8333,47.5 23.1667,47.5 22.5,47.5C 15.1667,39.5 7.5,31.8333 -0.5,24.5C -0.5,23.8333 -0.5,23.1667 -0.5,22.5C 7.5,15.1667 15.1667,7.5 22.5,-0.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.27092a5a9d9c75ae2f863af18efd6e5e.svg";
export { ForwardRef as ReactComponent };